<template>
    <div class="main">
        <div class="banner">
          <img src="@/assets/images/banner.png" />
        </div>
        <div class="login">
            <div class="login_head">
                <img src="@/assets/images/logo.png" />
            </div>
            <div class="login_body" v-loading="this.$store.state.loadingShow">
                <h1>报奖系统会员登录</h1>
                <el-form :model="loginInfo" status-icon ref="loginInfo" label-width="0" class="demo-ruleForm">
                    <el-form-item prop="mobile" :rules="{ required: true, validator: validatePhone, trigger: 'blur' }">
                      <el-input type="text" v-model="loginInfo.mobile" placeholder="手机号" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item prop="passwd" :rules="{ required: true, message: '请填写密码', trigger: 'blur' }">
                      <el-input type="password" v-model="loginInfo.passwd" placeholder="密码" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item v-if="!test" prop="token" :rules="{ required: true, message: '请输入验证', trigger: 'blur' }">
                        <validate @success="SetToken"></validate>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" style="width:100%;padding:.8em 0;font-size: 1.2em;;" size="large" @click="submitForm('loginInfo')">登 录</el-button>
                    </el-form-item>
                </el-form>
                <p class="align-center">
                    <router-link to="/register">注册</router-link> |
                    <router-link to="/getpassword">忘记密码</router-link>
                </p>
            </div>
        </div>
        <!-- <p></p> -->
    </div>
</template>

<script>
import * as API from '@/api/main'
import Validate from "@/components/Nc.vue";
export default {
name: '',
components: {
    Validate,
},
data() {
    return {
      loading:false,
        loginInfo:{
            mobile:"",
            passwd:"",
            token: ""
        },
      test:false,
    }
},
methods: {

    //校验手机号码
    validatePhone(rule, value, callback) {
        let phoneReg1 = /^1[3456789]\d{9}$/; //大陆手机号验证
        // let phoneReg2 = /^852(5|6|8|9)\d{7}$/;    //香港手机号验证
        if (!value) {
          return callback(new Error('请输入手机号码')) ;
        }
        setTimeout(() => {
          if (!phoneReg1.test(value) && value.indexOf("*")==-1) {
            callback(new Error('手机号码格式有误'));
          } else {
            callback();
          }
        }, 0)
      },
    
    //登录提交
    submitForm(formName){
      this.$store.state.loadingShow=true;
      var postdata=_.cloneDeep(this.loginInfo);
      // console.log(postdata)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.test){
            API.UserTestlogin(postdata).then(res => { 
              localStorage.setItem('user',JSON.stringify(res.data));
              if(res.data.token){
                localStorage.setItem('token',res.data.token);
              }              
              // this.$store.state.token=res.data.token;
              this.$router.push({path:'/home'});
              this.$store.state.loadingShow=false;
            })
          }else{
            LUOCAPTCHA.reset();
            this.loginInfo.token="";        
            API.Userlogin(postdata).then(res => { 
              localStorage.setItem('user',JSON.stringify(res.data));
              if(res.data.token){
                localStorage.setItem('token',res.data.token);
              }
              this.$router.push({path:'/home'});                
              this.$store.state.loadingShow=false;
            })
          }
        } else {
          this.$store.state.loadingShow=false;
          return false;
        }
      });
    },

    //重置校验
    resetForm(formName) {
        this.$refs[formName].resetFields();
    },

    SetToken(resp) {
    //   console.log(resp);
      this.loginInfo.token = resp;
    },

    //查看运行环境
    checktest(){
      var url=window.location.href;
      if(url.includes('localhost') || url.includes('192.168.6')){
        this.test=true;
      }else{
        this.test=false;
      }
    },

},
created() {
    localStorage.removeItem('auth');
    this.checktest();
},
}
</script>

<style scoped>   
    .banner{background:#D6000F;width: 100%;height:100px;text-align: center;}
    .login{width:480px;position: relative;border-radius: 10px;margin:50px auto 0;}
    .login::after{content:"@经观传媒 版权所有";position: absolute;text-align: center;width:100%;margin-top:10px;}
    .login_head{width:100%;text-align: center;padding:2em 0;border-radius: 10px 10px 0 0;}
    .login_head img{width:40%;}
    .login_body{width:100%;padding:2em 5em;box-sizing: border-box;background:#fff;box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);border:1px solid rgba(0, 40, 100, 0.12);border-top:4px solid var(--mainColor);}
    .login_body h1{text-align: left;font-size:1.2em;padding:1em 0;}
    p{width:100%;}
    @media screen and (max-width: 480px){
        .banner{display:none;}
        .login{width: 100%;margin:0;}
        .login_body{padding:2em 5%;margin:auto;}
    }
</style>
  